__turbopack_context__.v({
  "contained": "-5_oDq_contained",
  "container": "-5_oDq_container",
  "content": "-5_oDq_content",
});
